// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { supabase } from "./utils/supabaseClient";

import RootLayout from "./layouts/RootLayout"; // <-- create from earlier step
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";
import Dashboard from "./components/Dashboard";
import AverageCostCalculator from "./pages/AverageCostCalculator";
import "./App.css";

function ProtectedLayout({ session }) {
  if (!session) return <Navigate to="/login" replace />;
  // RootLayout renders Header + PageLayout + <Outlet/>
  return <RootLayout session={session} />;
}

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={session ? <Navigate to="/" replace /> : <Login />}
        />
        <Route path="/reset" element={<ResetPassword />} />

        {/* Protected app routes (all share RootLayout) */}
        <Route element={<ProtectedLayout session={session} />}>
          <Route index element={<Dashboard session={session} />} />
          <Route path="avg" element={<AverageCostCalculator session={session} />} />
        </Route>

        {/* Catch-all */}
        <Route
          path="*"
          element={<Navigate to={session ? "/" : "/login"} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}
